import config from './config/index.js';
import { CLIENT_TYPES } from './constants.js';
import Logger from './Logger/index.js';

export const getSignedDownloadUrl = async ({ uri, token }) => {
  const authorization = `Bearer ${token}`;

  const res = await fetch(uri, {
    headers: { Authorization: authorization },
  });

  const response = await res.json();

  if (response.error) {
    throw new Error(response.errors);
  }

  const data = response.data ? response.data : response;

  return data.attributes.download.url;
};

const openInSameTab = async ({ uri, token }) => {
  const downloadUri = await getSignedDownloadUrl({ uri, token });
  const link = document.createElement('a');
  link.href = downloadUri;
  link.click();
};

const openInNewTab = ({ uri, token }) => {
  const mediaWindowUrl = `${window.location.protocol}//${window.location.host}/media`;
  const mediaWindow = window.open(mediaWindowUrl);
  mediaWindow.onload = async () => {
    const downloadUri = await getSignedDownloadUrl({ uri, token });
    mediaWindow.location.replace(downloadUri);
  };
};

export const downloadMp3 = async ({ uri, name, token }) => {
  const format = 'mp3';
  const authorization = `Bearer ${token}`;

  const uriFormat = `${uri}/${format}`;

  const rs = await fetch(uriFormat, {
    headers: { Authorization: authorization },
  });

  if (rs.status !== 200) {
    return false;
  }

  const url = window.URL.createObjectURL(await rs.blob());
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  a.href = url;
  a.download = `${name}.${format}`;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();

  return true;
};

export const download = async ({ uri, token, name }) => {
  const downloadUri = await getSignedDownloadUrl({ uri: `${uri}?attachment=true`, token });
  const link = document.createElement('a');
  link.href = downloadUri;
  link.download = name;

  link.click();
};

export const open = async ({ uri, token }) => {
  try {
    if (config.CLIENT_TYPE === CLIENT_TYPES.MOBILE) {
      openInSameTab({ uri, token });
      return;
    }

    openInNewTab({ uri, token });
  } catch (e) {
    Logger.error(e);
  }
};
